import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { FeatureMgtState } from "./type";
import { generateQueryString } from "../helper/helpers";

export const getRemittanceRules = createAsyncThunk(
  "web/get-usd-remittance-rule",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/remittance-rules${generateQueryString(payload)}`
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_REMITTANCE_RULES(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const createRemittanceRule = createAsyncThunk(
  "web/create-remittance-rule",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.post("/admin/remittance-rules", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        // toast.success(data?.data?.message, {
        //   position: "top-right",
        //   theme: "colored",
        // });

        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const editRemittanceRule = createAsyncThunk(
  "web/edit-remittance-rule",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.put(
        `/admin/remittance-rules/${payload.id}`,
        payload.body
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        // toast.success(data?.data?.message, {
        //   position: "top-right",
        //   theme: "colored",
        // });

        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getRemittanceRulesHistory = createAsyncThunk(
  "web/get-usd-remittance-rule-history",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/remittance-rules/${payload.id}${generateQueryString(
          payload.param
        )}`
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_REMITTANCE_RULES_HISTORY(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

const initialState: FeatureMgtState = {
  loading: false,
  mutating: false,
  remittance_rules: {},
  remittance_rules_history: {},
};

export const featureManagementSlice = createSlice({
  name: "feature-management",
  initialState,
  reducers: {
    SET_REMITTANCE_RULES: (state, action) => {
      state.remittance_rules = action.payload;
    },
    SET_REMITTANCE_RULES_HISTORY: (state, action) => {
      state.remittance_rules_history = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRemittanceRules.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRemittanceRules.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getRemittanceRules.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createRemittanceRule.pending, (state) => {
        state.mutating = true;
      })
      .addCase(createRemittanceRule.fulfilled, (state) => {
        state.mutating = false;
      })
      .addCase(createRemittanceRule.rejected, (state) => {
        state.mutating = false;
      })
      .addCase(editRemittanceRule.pending, (state) => {
        state.mutating = true;
      })
      .addCase(editRemittanceRule.fulfilled, (state) => {
        state.mutating = false;
      })
      .addCase(editRemittanceRule.rejected, (state) => {
        state.mutating = false;
      })
      .addCase(getRemittanceRulesHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRemittanceRulesHistory.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getRemittanceRulesHistory.rejected, (state) => {
        state.loading = false;
      });
  },
});

// Action creators are generated for each case reducer function
export const { SET_REMITTANCE_RULES, SET_REMITTANCE_RULES_HISTORY } =
  featureManagementSlice.actions;

export default featureManagementSlice.reducer;
